import TasksTabContent from "../../_components/TasksTabContent";

export default function MyTasksPage() {
  return (
    <TasksTabContent source="my_tasks_tab" queryOptions={{ myTasks: true, showUnassignedChip: true }} hideUserChips />
  );
}
